import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GradientButtonCourse from '../ui/GradientButtonCourse/GradientButtonCourse';
import EventTypeBadge from '../ui/EventTypeBadge/EventTypeBadge';
import SpeakerBadge from '../ui/SpeakerBadge/SpeakerBadge';
import LocationBadge from '../ui/LocationBadge/LocationBadge';
import './EventCardCalendar.css';

interface EventCardProps {
  image: string;
  date: string;
  title: string;
  description: string;
  learnMoreLink: string;
  eventType: string;
  master: string;
  speakersLink: string;
  locationLink: string;
  location: string;
  eventPrice: string;
}

const EventCard: React.FC<EventCardProps> = ({
  image,
  date,
  title,
  description,
  learnMoreLink,
  eventType,
  master,
  location,
  speakersLink,
  locationLink,
  eventPrice
}) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  return (
    <div ref={cardRef} className={`event-card-calendar ${isVisible ? 'fade-in' : ''}`}>
      <div className="event-card-image-wrapper">
        <div className="event-location-badge">
          <EventTypeBadge type={eventType} />
        </div>
        <img src={image} alt={title} className="event-card-image-calendar" />
      </div>
      <div className="event-card-content">
        <div style={{ display: 'flex', gap: '10px', alignItems: 'baseline' }}>
          <p className="event-card-date">{date}</p>
          <LocationBadge location={location} link={locationLink} />
        </div>
        <SpeakerBadge speakersName={master} link={' '} />
        <h3 className="event-card-title">{title}</h3>
        
        <p className="event-card-description">{description}</p>
        <div className='event-calendar-card-price-container'>
          <p className="event-price-description">{t("price_for_event")}</p>
         <h2 className="event-price">{eventPrice}</h2>
        </div>
        
      </div>
    </div>
  );
};

export default EventCard;
